/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.

// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import reactUpdate from 'immutability-helper';
import moment from 'moment';
import React from 'react';
import _ from 'underscore';

import {pluralize} from 'BenchlingUtil';
import notifications from 'notifications';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import SortableTable from 'ui-library/SortableTable';
// @ts-expect-error
import formatDate from 'util/formatDate';
import * as net from 'util/Net';

// @ts-expect-error
import UserOpenReviews from './UserOpenReviews';

/* eslint-disable-next-line @typescript-eslint/unbound-method */
const {defaultColumn} = SortableTable;

const DATE_FORMAT = 'dddd, MMMM D, YYYY, h:mm a';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function prettyDuration(seconds: any) {
  if (!_.isNumber(seconds)) {
    return null;
  }
  const unit = (() => {
    switch (false) {
      case !(seconds > 60):
        return 'minutes';
      case !(seconds > 60 * 60):
        return 'hours';
      case !(seconds > 24 * 60 * 60):
        return 'days';
      default:
        return undefined;
    }
  })();
  const count = moment(seconds * 1000).diff(moment(0), unit);
  return `${count} ${pluralize(count, unit!)}`;
}

interface Props {
  organizationId: string;
}

type State = any;

class AdminUsersDashboard extends React.Component<Props, State> {
  state: State = {
    users: [],
    activeUser: null,
  };

  componentDidMount(): void {
    net
      .getJSON('/1/api/admin/users/', {organizationId: this.props.organizationId})
      .done((results: any) => {
        this.setState({users: results.users});
      })
      .fail(notifications.notifyError);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setActiveUser = (userSummary: any) =>
    net
      .getJSON(`/1/api/admin/users/${userSummary.id}`, {organizationId: this.props.organizationId})
      .done((userDetails: any) => {
        this.setState({activeUser: reactUpdate(userSummary, {$merge: userDetails})});
      })
      .fail(notifications.notifyError);

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  renderTable = () => {
    const rows = this.state.users;
    const columns = [
      defaultColumn('Username', 'handle'),
      defaultColumn('Open Reviews (Auditor)', 'openReviewsAsAuditor'),
      defaultColumn('Open Reviews (Author)', 'openReviewsAsAuthor'),
      defaultColumn('Entries Created (Last week)', 'entriesCreatedLastWeek'),
      defaultColumn('Reviews Created (Last week)', 'reviewsCreatedLastWeek'),
      defaultColumn('Reviews Audited (Last week)', 'reviewsAuditedLastWeek'),
      defaultColumn('Average Time to Review (Last week)', ' averageTimeToReviewLastWeek', {
        transform(value: any) {
          return prettyDuration(value) || 'N/A';
        },
      }),
    ];

    return (
      <SortableTable
        columns={columns}
        rows={rows}
        onClickRow={this.setActiveUser}
        clickable={true}
        selectable={true}
      />
    );
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  renderTraits = (user: any) => {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const renderTrait = (traitName: any, traitValue: any) => (
      <div>
        <dt>{traitName}</dt>
        <dd className="u-tiny-spacing-bottom">{traitValue}</dd>
      </div>
    );

    return (
      <Row>
        <Col sm={4}>
          <dl>
            {renderTrait('User', user.handle)}
            {renderTrait('Open Reviews (Auditor)', user.openReviewsAsAuditor)}
            {renderTrait('Open Reviews (Author)', user.openReviewsAsAuthor)}
          </dl>
        </Col>
        <Col sm={4}>
          <dl>
            {renderTrait('Entries created (last week)', user.entriesCreatedLastWeek)}
            {renderTrait('Reviews created (last week)', user.reviewsCreatedLastWeek)}
            {renderTrait('Reviews audited (last week)', user.reviewsAuditedLastWeek)}
          </dl>
        </Col>
        <Col sm={4}>
          <dl>
            {renderTrait(
              'Average Time to Review (last week)',
              prettyDuration(user.averageTimeToReviewLastWeek) || 'N/A'
            )}
            {renderTrait('Last seen', formatDate(user.lastSeen, DATE_FORMAT))}
          </dl>
        </Col>
      </Row>
    );
  };

  render(): JSX.Element {
    return (
      <div>
        <h1>Users Dashboard</h1>
        <Row>
          <Col sm={12}>{this.renderTable()}</Col>
        </Row>
        {this.state.activeUser != null ? (
          <div className="well">
            <h2>{`User Details: ${this.state.activeUser.handle}`}</h2>
            {this.renderTraits(this.state.activeUser)}
            <Row>
              <Col sm={12}>
                <UserOpenReviews openReviews={this.state.activeUser.openReviews} />
              </Col>
            </Row>
          </div>
        ) : (
          <div className="well">
            <h5 className="text-center">Select a user for detailed information.</h5>
          </div>
        )}
      </div>
    );
  }
}

export default AdminUsersDashboard;
